export const menuList = [
  {
    title: "header.aboutUs.title",
    list: [
      { name: "header.aboutUs.list.business", link: "/about/greeting" },
      { name: "header.aboutUs.list.greeting", link: "/about/organization" },
      { name: "header.aboutUs.list.vision", link: "/about/vision" },
      { name: "header.aboutUs.list.history", link: "/about/history" },
      { name: "header.aboutUs.list.ci", link: "/about/ci" },
    ],
  },
  {
    title: "header.digitaltwin.title",
    list: [
      { name: "header.digitaltwin.list.esg", link: "/digital-transformation/smart-green-esg" },
      { name: "header.digitaltwin.list.saas", link: "/digital-transformation/saas-platform" },
      { name: "header.digitaltwin.list.testbed", link: "/digital-transformation/testbed" },
    ],
  },
  {
    title: "header.globalit.title",
    list: [
      { name: "header.globalit.list.decarbon", link: "/esg-rnd/decarbonization" },
      { name: "header.globalit.list.certification", link: "/esg-rnd/global-certification" },
      { name: "header.globalit.list.energy", link: "/esg-rnd/carbon-neutral-energy" },
    ],
  },
  {
    title: "header.design.title",
    list: [
      { name: "header.design.list.solution", link: "/design/esg-design" },
      { name: "header.design.list.urban", link: "/design/smart-landscape" },
      { name: "header.design.list.gallery", link: "/design/gallery" },
    ],
  },
  {
    title: "header.consulting.title",
    list: [
      { name: "header.consulting.list.total", link: "/eco-planning/eco-consulting" },
      { name: "header.consulting.list.simulation", link: "/eco-planning/environment-simulation" },
    ],
  },
  {
    title: "header.news.title",
    list: [
      { name: "header.news.list.press", link: "/news/press" },
      { name: "header.news.list.academy", link: "/news/academy" },
    ],
  },
  {
    title: "header.trackrecord.title",
    list: [
      { name: "header.trackrecord.list.housing", link: "/projects/residential" },
      { name: "header.trackrecord.list.project", link: "/projects/project-list" },
      { name: "header.trackrecord.list.year", link: "/projects/yearly" },
      { name: "header.trackrecord.list.client", link: "/projects/clients" },
      { name: "header.trackrecord.list.equipment", link: "/projects/equipment" },
    ],
  },
  // { title: "header.solution.title", list: [] },

  // {
  //   title: "header.aboutUs.title",
  //   titleLink: "",
  //   list: ["header.aboutUs.list.business", "header.aboutUs.list.greeting", "header.aboutUs.list.vision", "header.aboutUs.list.history", "header.aboutUs.list.ci"],
  //   listLink: "/about",
  // },
  // { title: "header.digitaltwin.title", titleLink: "", list: ["header.digitaltwin.list.esg", "header.digitaltwin.list.saas", "header.digitaltwin.list.testbed"], listLink: "/digitaltwin" },
  // { title: "header.globalit.title", titleLink: "", list: ["header.globalit.list.decarbon", "header.globalit.list.certification", "header.globalit.list.energy"], listLink: "/globalit" },
  // { title: "header.design.title", titleLink: "", list: ["header.design.list.solution", "header.design.list.urban", "header.design.list.gallery"], listLink: "/design" },
  // { title: "header.consulting.title", titleLink: "", list: ["header.consulting.list.total", "header.consulting.list.simulation"], listLink: "/consulting" },
  // { title: "header.news.title", titleLink: "", list: ["header.news.list.press", "header.news.list.academy"], listLink: "/news" },
  // {
  //   title: "header.trackrecord.title",
  //   titleLink: "",
  //   list: ["header.trackrecord.list.housing", "header.trackrecord.list.project", "header.trackrecord.list.year", "header.trackrecord.list.client", "header.trackrecord.list.equipment"],
  //   listLink: "/trackrecord",
  // },
  // { title: "header.solution.title", titleLink: "/#/design", list: [], listLink: "" },
];
